module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_165337_HDR-removebg-preview-c85945b84cb6c370d2314dc4473565b7.png";